// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "primary_phone_number",
                Decco.stringToJson(v.primary_phone_number)
              ],
              [
                "secondary_phone_number",
                Decco.optionToJson(Decco.stringToJson, v.secondary_phone_number)
              ],
              [
                "template_id",
                Decco.intToJson(v.template_id)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
